export interface Product {
  id: number;
  name: string;
  slug: string;
  parent: number;
  type: ProductType;
  variation: string;
  permalink: string;
  sku: string;
  short_description: string;
  description: string;
  on_sale: boolean;
  prices: ProductPrices;
  price_html: string;
  average_rating: string;
  review_count: number;
  images: ProductImage[];
  categories: ProductCategory[];
  tags: ProductTag[];
  attributes: ProductAttribute[];
  variations: ProductVariation[];
  has_options: boolean;
  is_purchasable: boolean;
  is_in_stock: boolean;
  is_on_backorder: boolean;
  low_stock_remaining: number;
  sold_individually: boolean;
  add_to_cart: AddToCartData;
  extensions: Record<string, unknown>;
}

export interface ProductPrices {
  price: string;
  regular_price: string;
  sale_price: string;
  price_range: PriceRange | null;
  currency_code: string;
  currency_symbol: string;
  currency_minor_unit: number;
  currency_decimal_separator: string;
  currency_thousand_separator: string;
  currency_prefix: string;
  currency_suffix: string;
}

export interface PriceRange {
  max_amount: string;
  min_amount: string;
}

export interface ProductImage {
  id: number;
  src: string;
  thumbnail: string;
  srcset: string;
  sizes: string;
  name: string;
  alt: string;
}

export interface ProductCategory {
  id: number;
  name: string;
  slug: string;
  link: string;
}

export interface ProductTag {
  id: number;
  name: string;
  slug: string;
  link: string;
}

export interface ProductAttribute {
  id: number;
  name: string;
  taxonomy: string;
  has_variations: boolean;
  terms: AttributeTerm[];
}

export interface AttributeTerm {
  id: number;
  name: string;
  slug: string;
}

export interface ProductVariation {
  id: number;
  attributes: VariationAttribute[];
}

export interface VariationAttribute {
  name: string;
  value: string;
}

export interface AddToCartData {
  text: string;
  description: string;
  url: string;
  minimum: number;
  maximum: number;
  multiple_of: number;
}

export enum ProductType {
  Simple = "simple",
  Variable = "variable",
  Grouped = "grouped",
  External = "external",
}

export enum StockStatus {
  InStock = "instock",
  OutOfStock = "outofstock",
  OnBackOrder = "onbackorder",
}

export enum ProductCategoryName {
  FloralFruity = "floral-fruity",
  Nutty = "nutty",
}
